export default  {
    bindings: {
        'displayType': '@'
    },
    controller: 'basketIndicatorController',
    template: require('../views/basket.indicator.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/basket.indicator.component.js